
import { useEffect, useState } from "react";
const Field = ({ label, children }) => <label className="settings-field"><span>{label}</span>{children}</label>;
const Check = ({ label, checked, onChange }) => <label className="settings-check"><input type="checkbox" checked={!!checked} onChange={(e)=>onChange(e.target.checked)} /> {label}</label>;
function useSection(value){ const [form,setForm]=useState(value||{}); useEffect(()=>setForm(value||{}),[value]); const set=(field,val)=>setForm((c)=>({...c,[field]:val})); return [form,set]; }
export { Field, Check, useSection };
